const Api = {
  Info: '/api/v2/merchant/merchant/',
}
export default (request) => {
  return {
    info: (params) => request.get(`${Api.Info}${params.merchant_id}`),
    key: (params) => request.put(`${Api.Info}${params.merchant_id}/api_key`)
  }
}
